<template>
  <div class="w-main">
    <div class="w-header flex">
      <div class="info">
        <el-image style="width: 50px; height: 50px;margin-right: 20px;" :src="logo" fit="fill"></el-image>
        <span>名片模版</span>
      </div>
      <el-row class="operate">
        <el-button type="primary" @click="handleSave">保存</el-button>
        <!-- <el-button type="primary">发布</el-button> -->
      </el-row>
    </div>
    <div class="w-content">
      <!-- 手机端展示效果 -->
      <div class="w-center">
        <div class="phone-box-w">
          <div class="phone-box-header">
            <el-image style="width: 100%; height: 88px" :src="phoneHeader"></el-image>
          </div>
          <!-- <span class="service"></span> -->
          <div class="phone-box-inner">
            <el-image
            style="width: 373px; height: 488px;margin-top:-6px;"
            :src="headerModule"
            fit="contain"></el-image>
            <div class="user-operate">
              <span>
                <i class="icon call-icon" />
                打电话
              </span>
              <span>
                <i class="icon wechat-icon" />
                加微信
              </span>
              <!-- <span>
                <i class="el-icon-map-location" />
                收名片
              </span> -->
              <span>
                <i class="icon like-icon" />
                推荐TA
              </span>
              <span>
                <i class="icon recommend-icon" />
                收名片
              </span>
            </div>
            <!-- <div class="module-item header">
              <span class="company-name">
                <el-image
                  class="company-img"
                  src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                  fit="fill"
                ></el-image>{{companyName}}
              </span>
              <div class="member">
                <el-image
                  class="header-img"
                  style="width:60px;height:60px;"
                  src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                  fit="fill"
                ></el-image>
                <p>
                  <span class="name">老潘</span>
                  <span class="position">董事长</span>
                </p>
              </div>
              <div class="company">
                <span class="label">
                  <i class="el-icon-phone-outline" />18888888888
                </span>
                <span class="label">
                  <i class="el-icon-chat-dot-round" />asikalte
                </span>
                <span class="label">
                  <i class="el-icon-map-location" />江苏省南京市雨花客厅B座8楼
                </span>
              </div>
            </div>

            <div class="introduce">
              我是XXX的创始人，对于碳中和有自己的心得，欢迎大家与我沟通联系，已服务于中国200多家环保企业，经验十分丰富。
              <p class="customer">
                <el-image
                  class="customer-img"
                  src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                  fit="fill"
                ></el-image>
                <el-image
                  class="customer-img"
                  src="https://resource.aijiatui.com/bm/qf2lr7l65100.png"
                  fit="fill"
                ></el-image>
                <el-image
                  class="customer-img"
                  src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                  fit="fill"
                ></el-image>
                <el-image
                  class="customer-img"
                  src="https://resource.aijiatui.com/bm/qf2lr7l65100.png"
                  fit="fill"
                ></el-image>
                <el-image
                  class="customer-img"
                  src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                  fit="fill"
                ></el-image>
                <span>已服务2000多人</span>
              </p>
            </div> -->
            <div class="module-item">
              <div class="website about-website">
                  <div class="module-title items-start">
                    <span class="title-name">企业官网</span>
                  </div>
                  <div class="text-box article-box flex">
                    <div class="header-img-box">
                      <el-image
                        class="title-icon"
                        style="width:61px;height:44px;"
                        src="http://outer-crm-test.oss-cn-shanghai.aliyuncs.com/crm/b39674fa-9cff-412c-8282-5d0347008ec7.png"
                        fit="contain"
                      ></el-image>
                    </div>
                    <div class="content-box">
                      <p class="article-title" style="margin-top:10px;">南京瑞洁特膜分离科技有限公司</p>
                    </div>
                  </div>
                </div>
            </div>


            <template v-for="(item,index) in appInfos">
              <div class="module-item" :key="index">
                <!-- 企业文章模块 -->
                <div class="website about-website" v-if="item.moduleCode === 3">
                  <div class="module-title items-start">
                    <!-- <el-image class="title-icon" :src="item.moduleIcon"></el-image> -->
                    <span class="more">
                      更多
                      <i class="el-icon-arrow-right" />
                    </span>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="no-data" v-if="item.content.length === 0">从右侧设置栏添加企业文章</div>
                  <template v-else>
                    <div class="text-box article-box flex" v-for="article in item.content">
                      <div class="header-img-box">
                        <el-image
                          class="title-icon"
                          style="width:94px;height:74px;"
                          :src="article.headPicUrl"
                          fit="cover"
                        ></el-image>
                      </div>
                      <div class="content-box">
                        <p class="article-title">{{article.title}}</p>
                        <div class="article-info" style="color: #333;margin-top:10px">
                          <el-image
                            class="title-icon"
                            style="width:17px;height:17px;border-radius:50%;vertical-align:middle;"
                            :src="article.companyLogo"
                            fit="cover"
                          ></el-image>
                          {{article.tenantName}}
                          <span style="color:#666;margin-left:10px">{{article.appShowPublishTimeStr}}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 案例，产品模块 -->
                <div
                    class="website about-website"
                    v-if="item.moduleCode === 2 || item.moduleCode === 4"
                  >
                  <div class="module-title items-start">
                    <!-- <el-image class="title-icon" :src="item.moduleIcon"></el-image> -->
                    <span class="more">
                      更多
                      <i class="el-icon-arrow-right" />
                    </span>
                    <span class="title-name">{{item.moduleName}}</span>
                  </div>
                  <div class="img-box">
                    <div class="slide-img" v-if="item.content.length === 0">
                      <span class="img"></span>
                      <span class="img"></span>
                      <span class="img"></span>
                    </div>
                    <div class="slide-img" v-else>
                      <span class="img" v-for="product in item.content">
                        <el-image
                          class="title-icon"
                          style="width:100%;height:100%;"
                          :src="product.headPicUrl"
                          fit="cover"
                        ></el-image>
                      </span>
                      <span class="img"></span>
                    </div>
                  </div>
                </div>

              </div>
            </template>
            <!-- 图片模块 -->
            <div class="module-item">
                <div class="website">
                  <div class="module-title items-start">
                    <!-- <el-image class="title-icon" :src="iconArr[0]"></el-image> -->
                    <span class="more">
                      更多
                      <i class="el-icon-arrow-right" />
                    </span>
                    <span class="title-name">我的相册</span>
                  </div>
                  <div class="img-box">
                    <div class="four-img">
                      <span class="img">
                        <el-image class="title-icon" :src="icon1"></el-image>
                      </span>
                      <span class="img">
                        <el-image class="title-icon" :src="icon2"></el-image>
                      </span>
                      <span class="img">
                        <el-image class="title-icon" :src="icon3"></el-image>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 视频模块 -->
                <div class="website video-website">
                  <div class="module-title items-start">
                    <!-- <el-image class="title-icon" :src="iconArr[0]"></el-image> -->
                    <span class="title-name">我的视频</span>
                    <span class="more">
                      更多
                      <i class="el-icon-arrow-right" />
                    </span>
                  </div>
                  <div class="video-box">
                    <div class="video"></div>
                    <p class="p">我的日常</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <!-- 右侧配置 -->
      <div class="w-right">
        <p class="set-title">编辑名片默认内容</p>
        <el-collapse v-model="activeName" @change="handleChange">
          <el-collapse-item title="名片样式" name="1">
            <div>
              <el-image style="width: 206px; height: 128px" :src="cardIcon" fit="contain"></el-image>
            </div>
          </el-collapse-item>
          <el-collapse-item title="名片信息" name="2">
            <el-form label-width="85px" label-position="left">
              <!-- <el-form-item label="公司简称：">
                <el-input v-model="companyName"></el-input>
              </el-form-item> -->
              <el-form-item label="员工头像：">员工编辑</el-form-item>
              <el-form-item label="职务：">员工职务展示</el-form-item>
              <el-form-item label="手机号：">员工编辑</el-form-item>
              <el-form-item label="微信号：">员工编辑</el-form-item>
              <el-form-item label="地址：">公司地址展示</el-form-item>
            </el-form>
          </el-collapse-item>
          <el-collapse-item title="企业官网" name="3">
            <el-form label-width="85px" label-position="left">
              <el-form-item label="企业官网：">公司企业官网自动跳转</el-form-item>
            </el-form>
          </el-collapse-item>
          <el-collapse-item title="推荐产品" name="4">
            <el-form label-width="100%" label-position="left">
              <el-form-item label="管理员可配置在员工固定展示的推荐产品，配置后排序优先展示，也可由员工自行配置"></el-form-item>
            </el-form>
            <el-button type="primary"  @click="add(3,'添加产品')">添加产品</el-button>
            <span> 管理员最多可配置5个</span>
            <div class="goods-box flex"v-for="(item,index) in appInfos[0].content">
              <i class="el-icon-circle-close close-btn"  @click="delItem(0, index)"/>
              <div class="header-img-box">
                <el-image
                  class="title-icon"
                  style="width:60px;height:60px;"
                  :src="item.headPicUrl"
                  fit="contain"
                ></el-image>
              </div>
              <div class="content-box">
                <p class="article-title">{{item.title}}</p>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="热门文章" name="5">
            <el-form label-width="100%" label-position="left">
              <el-form-item label="管理员可配置在员工固定展示的热门文章，配置后排序优先展示，也可由员工自行配置"></el-form-item>
            </el-form>
            <el-button type="primary" @click="add(1,'添加文章')">添加文章</el-button>
            <span> 管理员最多可配置5个</span>

            <div class="goods-box flex" v-for="(item,index) in appInfos[1].content">
              <i class="el-icon-circle-close close-btn"  @click="delItem(1, index)"/>
              <div class="header-img-box">
                <el-image
                  class="title-icon"
                  style="width:60px;height:60px;"
                  :src="item.headPicUrl"
                  fit="contain"
                ></el-image>
              </div>
              <div class="content-box">
                <p class="article-title">{{item.title}}</p>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="经典案例" name="6">
            <el-form label-width="100%" label-position="left">
              <el-form-item label="管理员可配置在员工固定展示的经典案例，配置后排序优先展示，也可由员工自行配置"></el-form-item>
            </el-form>
            <el-button type="primary" @click="add(2,'添加案例')">添加案例</el-button>
            <span> 管理员最多可配置5个</span>
            <div class="goods-box flex" v-for="(item,index) in appInfos[2].content">
              <i class="el-icon-circle-close close-btn" @click="delItem(2, index)"/>
              <div class="header-img-box">
                <el-image
                  class="title-icon"
                  style="width:60px;height:60px;"
                  :src="item.headPicUrl"
                  fit="contain"
                ></el-image>
              </div>
              <div class="content-box">
                <p class="article-title">{{item.title}}</p>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="相册" name="7">
            <el-form label-width="100%" label-position="left">
              <el-form-item label="员工自行配置"></el-form-item>
            </el-form>
          </el-collapse-item>
          <el-collapse-item title="视频" name="8">
            <el-form label-width="100px" label-position="left">
              <el-form-item label="员工自行配置"></el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- 产品，文章，案例列表 -->
    <el-dialog :title="title" :visible.sync="dialogTableVisible">
      <el-table :data="list" ref="multipleTable" @selection-change="handleSelectionChange" style="max-height:500px;overflow:auto;">
        <el-table-column
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <!-- 多选 -->
        <el-table-column label="内容标题"  prop="title"></el-table-column>
        <el-table-column label="封面图" width="240" prop="title">
          <template slot-scope="scope">
            <el-image v-for="item in scope.row.headPicUrlList" style="width: 60px;margin-right: 5px"
                      :src="item" fit="contain"/>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="200" prop="appShowPublishTimeStr"></el-table-column>
      </el-table>
      <!-- <el-pagination
        small
        style="margin-top:10px;"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        :total="total"
        @pagination="queryArticleList"
      ></el-pagination> -->
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="toggleSelection">设置</el-button> -->
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmArticle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import phoneHeader from "@/assets/decorate/header-icon.png";
import cardIcon from "@/assets/decorate/card-style.png";
import icon1 from "@/assets/decorate/icon1.png";
import icon2 from "@/assets/decorate/icon2.png";
import icon3 from "@/assets/decorate/icon3.png";
import headerModule from '@/assets/decorate/header-module.png'
import { iconArr} from './components/websiteConfig'
import {
  queryArticleList,
  businessCard,
  businessCardDetail
} from "@/api/saas/package";
export default {
  name: "Card",
  data() {
    return {
      headerModule,
      icon1,
      icon2,
      icon3,
      title: '', // 弹框名称
      queryParams: { // 查询产品，案例，文章列表
        pageNo: 1,
        pageSize: 1000000,
        status: 1,
        articleType: null,
      },
      total: 0,
      dialogTableVisible: false,
      list: [], // 产品，案例，文章列表
      selectItem: [],
      companyName: 'XXXXXXX',
      activeName: ["1", "2"], // 右侧编辑模块默认展开模块
      phoneHeader,
      cardIcon,
      logo: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      appInfos: [
        {
          moduleName: "推荐产品",
          moduleCode: 2,
          moduleIcon: 'http://outer-crm-test.oss-cn-shanghai.aliyuncs.com/crm/5035fe99-60ee-4be9-99ba-c082d35c52f7.png',
          content: [], // 文章列表
        },
        {
          moduleName: "热门文章",
          moduleCode: 3,
          moduleIcon: 'http://outer-crm-test.oss-cn-shanghai.aliyuncs.com/crm/5035fe99-60ee-4be9-99ba-c082d35c52f7.png',
          content: [], // 文章列表
        },
        {
          moduleName: "经典案例",
          moduleCode: 4,
          moduleIcon: 'http://outer-crm-test.oss-cn-shanghai.aliyuncs.com/crm/5035fe99-60ee-4be9-99ba-c082d35c52f7.png',
          content: [], // 文章列表
        }
      ],
      iconArr,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {
    this.businessCardDetail() // 获取配置详情
  },
  methods: {
    toggleSelection(rows) {
      console.log('rows--', rows)
      if (rows) {
        rows.forEach(row => {
          this.$nextTick(() => {
            this.$refs.multipleTable.toggleRowSelection(row);
          })
        });
      } else {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
        })
      }
    },
    handleChange(val) {
      console.log(val);
    },
    handleCurrentChange(value) {
      this.params.pageNo = value;
    },
    handleSizeChange(value) {
      this.params.pageSize = value;
    },
    add(type, title) {
      this.queryParams.pageNo = 1;
      this.title = title;
      this.dialogTableVisible = true;
      this.queryParams.articleType = type
      this.queryArticleList()
    },
    businessCardDetail() {
      businessCardDetail()
        .then(response => {
          // this.appInfos = response.data.moduleList
          let moduleList = response.data.moduleList
          moduleList.forEach(item => {
            if(item.moduleCode === 2) {
              this.appInfos[0].content = item.content
            }else if(item.moduleCode === 3) {
              this.appInfos[1].content = item.content

            }else if(item.moduleCode === 4) {
              this.appInfos[2].content = item.content
            }
          })
          this.companyName = response.data.companyName
          console.log('companyName', companyName, 'response.data.companyName', response.data.companyName)
          // this.form = this.appInfos[0];
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 获取产品，文章，案例列表
    queryArticleList() {
      this.loading = true;
      queryArticleList(Object.assign(this.queryParams))
        .then(response => {
          this.list = response.rows || [];
          this.loading = false;
          this.total = response.total;
          // 设置默认选中
          let selectArr = []
          let currentArr = []
          // 获取当前文章，产品，案例和接口获取的文章进行对比，进行选中
          const type = this.queryParams.articleType
          if(type === 3){ // 产品
            currentArr = this.appInfos[0].content
          }else if(type === 1) { // 文章
            currentArr = this.appInfos[1].content
          }else { // 案例
            currentArr = this.appInfos[2].content
          }
          // 直接用currentArr会选不中
          currentArr.forEach(item => {
            this.list.forEach(listItem => {
              if(item.articleId === listItem.articleId){
                selectArr.push(listItem)
              }
            })
          })
          setTimeout(()=> {
            this.toggleSelection(selectArr)
          }, 100)
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleSelectionChange(e){
      this.selectItem = e
    },
    confirmArticle() {
      if(this.selectItem.length <= 5) {
        const type = this.queryParams.articleType
        if(type === 3) {
          this.appInfos[0].content = this.selectItem
        }else if(type === 1) {
          this.appInfos[1].content = this.selectItem

        }else if(type === 2) {
          this.appInfos[2].content = this.selectItem
        }
        this.selectItem = []
        this.dialogTableVisible = false
        this.total = 0
      }else {
        this.msgWarning("最多可添加五个");
      }
    },
    // 保存官网配置
    handleSave() {
      businessCard({
        style: 1,
        companyName: this.companyName,
        moduleList: this.appInfos
      }).then(response => {
          this.msgSuccess("名片保存成功");
        })
        .catch(error => {
          this.loading = false;
        });
    },
    addarticle() {},
    addCase() {},
    addProduct() {},
    addManage() {},
    handleFileChange(fileObjs) {
      this.form.fileObjs = fileObjs;
    },
    delItem(moduleIndex, itemIndex) {
      const that = this
        this.$confirm('确认要删除该条数据?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          console.log('moduleIndex', moduleIndex,'itemIndex', itemIndex)
          that.appInfos[moduleIndex].content.splice(itemIndex, 1)
        }).then(response => {
        })
    }
  }
};
</script>

<style lang='scss' scoped>
.w-main {
  height: 100%;
  .introduce {
    font-size: 12px;
    color: #333;
    line-height: normal;
    margin: 15px;
    .customer {
      margin-left: 10px;
      .customer-img {
        float: left;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-left: -10px;
      }
      > span {
        line-height: 28px;
        margin-left: 5px;
      }
    }
  }
  .user-operate {
    position: absolute;
    width: 100%;
    top: 353px;
    margin-left: 0;
    background: #fff;
    padding: 0;
    border-width: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon{
      display: inline-block;
      width: 36px;
      height: 36px;
      &.call-icon{
        background: url(../../../../assets/decorate/call-icon.png) no-repeat center;
        background-size: 100% 100%;
      }&.wechat-icon{
        background: url(../../../../assets/decorate/wechat-icon.png) no-repeat center;
        background-size: 100% 100%;
      }&.like-icon{
        background: url(../../../../assets/decorate/like-icon.png) no-repeat center;
        background-size: 100% 100%;
      }&.recommend-icon{
        background: url(../../../../assets/decorate/recommend-icon.png) no-repeat center;
        background-size: 100% 100%;
      }
    }
    > span {
      font-size: 12px;
      color: #333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      > i {
        font-size: 18px;
        margin-bottom: 4px;
      }
    }
  }
  .header {
    position: relative;
    margin: 15px;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.34902);
    border-radius: 6px;
    .company-name {
      position: absolute;
      font-size: 12px;
      color: #333;
      right: 8px;
      top: 8px;
      .company-img {
        height: 12px;
        width: 12px;
        border-radius: 50%;
        margin-right: 1px;
        vertical-align: middle;
        margin-top: -2px;
      }
    }
    .member {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-bottom: 1px solid #eee;
      .header-img {
        margin: 20px 0 0;
        border-radius: 50%;
      }
      .name {
        font-size: 18px;
        color: #333;
        font-weight: bold;
        margin-right: 20px;
      }
      .position {
        font-size: 12px;
        color: #555;
      }
    }
    .company {
      padding: 20px 0;
      background: rgb(247, 247, 247);
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      .label {
        display: inline-block;
        font-size: 12px;
        color: #7f7f7f;
        margin-left: 48px;
        margin-bottom: 10px;
        i {
          margin-right: 8px;
        }
      }
    }
  }
  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .goods-box {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 375px;
    min-height: 76px;
    margin-bottom: 16px;
    padding: 8px;
    color: #666;
    font-size: 14px;
    background: #fff;
    border: 1px solid #f2f2f6;
    justify-content: left;
    margin-top: 5px;
    &:hover {
      .close-btn {
        display: block;
      }
    }
    .close-btn {
      display: none;
      position: absolute;
      top: -5px;
      right: 0;
      color: #ff6767;
      cursor: pointer;
    }
    .header-img-box {
      display: inline-block;
      width: 60px;
      height: 60px;
      margin-right: 8px;
    }
    .content-box {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  ::v-deep.el-collapse-item__header {
    padding-left: 16px;
  }
  ::v-deep.el-collapse-item__content {
    padding: 4px 16px 16px;
  }
  ::v-deep.el-collapse-item__header,
  ::v-deep.el-collapse-item__wrap {
    background: #fafafa;
    font-size: 14px;
  }
  ::v-deep.ant-collapse-borderless > .ant-collapse-item {
    border-bottom: 1px solid #d9d9d9;
  }
  .w-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 64px;
    color: #fff;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    padding: 0 30px;
    align-content: left;
    z-index: 9;
    .info {
      flex: 1;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.65);
      justify-content: left;
      align-items: center;
      display: flex;
    }
    .operate {
      flex: 1;
      text-align: right;
    }
  }
  .w-content {
    position: fixed;
    left: 0;
    right: 0;
    top: 64px;
    bottom: 0;
    width: 100%;
    display: flex;
    z-index: 8;
    .w-left {
      width: 330px;
      height: 100%;
      background-color: #fff;
      box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2);
      overflow: auto;
      .w-title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #e1e1e1;
        margin: 0;
      }
      .w-module {
        overflow: hidden;
      }
      .module {
        float: left;
        width: 110px;
        height: 110px;
        text-align: center;
        border-right: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        cursor: pointer;
        color: #666;
        &:nth-child(3n) {
          border-right: none;
        }
        &:hover {
          color: #2d7ee8;
          background: rgb(236, 243, 253);
        }
        .module-name {
          font-size: 14px;
        }
        .module-cion {
          display: block;
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 32px;
        }
      }
    }
    .w-right {
      width: 50%;
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
      .set-title {
        height: 50px;
        padding-left: 20px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        line-height: 50px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        margin: 0;
      }
    }
    .w-center {
      flex: 1;
      overflow-y: auto;
      background-color: #f0f0f0;
      .phone-box-w {
        width: 375px;
        margin: 100px auto;
        border: 1px solid #c1cddb;
        background-color: #F5F5F5;
        position: relative;
        .service{
          position: absolute;
          display: inline-block;
          width: 40px;
          height: 40px;
          background: url(../../../../assets/decorate/service-icon.png) no-repeat center;
          background-size: 100% 100%;
          top: 350px;
          right: 0px;
        }
        .module-item {
          position: relative;
          .website {
            width: 100%;
            padding: 0 15px 0;
            overflow: hidden;
            &.img-website,
            &.slide-website {
              padding: 0;
              > div {
                width: 100%;
              }
              .type-1 {
                height: 200px;
              }
              .type-2 {
                height: 348px;
              }
              .type-3 {
                height: 531px;
              }
            }
            &.video-website,
            &.about-website {
              padding: 15px;
            }
            .text-box {
              width: 100%;
              padding: 15px;
              background: #fff;
              border-radius: 4px;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              line-height: 1.5;
              &.article-box {
                justify-content: left;
                align-items: flex-start;
                .header-img-box {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
                .content-box {
                  margin-left: 15px;
                  &.office {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 40px;
                    .article-title {
                      font-weight: normal;
                    }
                  }
                  .article-title {
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.65);
                    display: -webkit-box;
                    white-space: normal;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    font-weight: 550;
                    margin: 0;
                    overflow: hidden;
                  }
                  .article-info {
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
              .h3 {
                color: #333;
                font-weight: 700;
                font-size: 15px;
                margin: 0;
              }
              .h4 {
                margin: 0;
                color: #666;
                word-break: break-all;
                font-weight: 400;
                font-size: 14px;
              }
              .p {
                margin: 0;
                color: #666;
                word-break: break-all;
                font-size: 14px;
              }
            }
            .img-box {
              overflow: hidden;
              width: 2000%;
              //   padding: 15px;
              .single-img {
                height: 528px;
                background: url(../../../../assets/decorate/single-img-bg.png) no-repeat
                  center;
                background-size: 100% 100%;
              }
              .slide-img {
                display: flex;
                width: 200%;
                overflow: hidden;
                &.pic {
                  padding: 15px;
                }
                .img {
                  display: inline-block;
                  width: 220px;
                  height: 127px;
                  margin-right: 15px;
                  border-radius: 4px;
                  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
                  background: url(../../../../assets/decorate/single-img-bg.png) no-repeat
                    center;
                  background-size: 100%;
                }
              }
              .three-img {
                position: relative;
                display: flex;
                justify-content: space-between;
                .img {
                  display: inline-block;
                  width: 118px;
                  height: 68px;
                  background: url(../../../../assets/decorate/single-img-bg.png) no-repeat
                    center;
                  background-size: 100%;
                  &:first-child {
                    width: 210px;
                    height: 150px;
                  }
                  &:last-child {
                    position: absolute;
                    right: 15px;
                    bottom: 15px;
                  }
                }
              }
              .four-img {
                position: relative;
                display: flex;
                // justify-content: space-between;
                flex-wrap: wrap;
                .img {
                  display: inline-block;
                  width: 105px;
                  height: 105px;
                  background: url(../../../../assets/decorate/single-img-bg.png) no-repeat
                    center;
                  background-size: 100%;
                  margin-bottom: 15px;
                  margin-right: 15px;
                }
              }
              //   .three-img {
              //     height: 528px;
              //     background: url(@/assets/decorate/single-img-bg.png)
              //       no-repeat center;
              //     background-size: 100% 100%;
              //   }
            }
            .video-box {
              overflow: hidden;
              background: #fff;
              border-radius: 4px;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              .video {
                position: relative;
                height: 184px;
                background: url(../../../../assets/decorate/video.png) no-repeat
                  center;
                background-size: 100%;
                &:after {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  display: block;
                  width: 60px;
                  height: 60px;
                  background: url(../../../../assets/decorate/video-bg.png) no-repeat 50% /
                    contain;
                  -webkit-transform: translate(-50%, -50%);
                  -ms-transform: translate(-50%, -50%);
                  transform: translate(-50%, -50%);
                  content: "";
                }
              }
              .p {
                display: block;
                padding: 15px;
                margin: 0;
                color: #333;
                font-weight: 700;
                font-size: 15px;
              }
            }
          }
        }
        .module-title {
          position: relative;
          display: flex;
          align-items: center;
          line-height: 70px;
          .more {
            position: absolute;
            top: 3px;
            right: 0;
            font-size: 13px;
            color: #999;
            cursor: pointer;
          }
          &.items-start {
            line-height: 1.5;
            margin-bottom: 20px;
          }
          .title-icon {
            display: block;
            width: 24px;
            height: 24px;
          }
          .title-name {
            padding-left: 5px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .image-slot {
    background: url(../../../../assets/decorate/single-img-bg.png) no-repeat center;
    background-size: 100% 100%;
  }
  .form-box {
    padding: 24px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  ::v-deep.el-form-item__label {
    color: #333;
    font-weight: normal;
  }
  .title-icon-box {
    display: flex;
    flex-wrap: wrap;
  }
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin: 0 20px 16px 0;
    text-align: center;
    cursor: pointer;
  }
  .icon-box.current {
    background: url(../../../../assets/decorate/current-icon.png) no-repeat top;
    background-size: 40px 40px;
  }
  .img-content {
    padding: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    .img-list {
      overflow: hidden;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      .img-bg {
        float: left;
        margin-right: 15px;
        margin-bottom: 10px;
        background: url(../../../../assets/decorate/img-bg.png) no-repeat center;
        background-size: 100%;
        width: 94px;
        height: 45px;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .contact-content {
    padding: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 10px;
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    .label-icon {
      width: 50px;
      height: 50px;
      font-size: 30px;
      color: #999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .label-content {
      border-left: 1px solid #e1e1e1;
      padding-left: 10px;
      min-height: 50px;
      flex: 1;
      .label-title {
        color: #999;
        font-size: 12px;
        margin-bottom: 1em;
        margin-top: 5px;
      }
      .label-info {
        word-break: break-all;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }
    }
  }
  .manage-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .manage-list {
      position: relative;
      width: 163px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
      margin-top: 40px;
      .header-bg {
        position: absolute;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: url(../../../../assets/decorate/img-bg.png) no-repeat center;
        background-size: 100%;
        left: 41px;
        top: -40px;
        overflow: hidden;
      }
      .text {
        padding: 56px 15px 15px;
        text-align: center;
      }
      .title {
        color: #333;
        font-weight: 700;
        font-size: 15px;
        line-height: 1.8;
      }
      .sub-title {
        color: #afafaf;
        font-size: 12px;
        line-height: 1.8;
      }
      .intro {
        color: #666;
        font-size: 14px;
        line-height: 1.8;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  .no-data {
    height: 210px;
    background-color: #ddd;
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .carousel-box {
    position: relative;
    display: flex;
    margin-bottom: 12px;
    padding: 16px;
    color: #666;
    background-color: #f5f5f5;
    .jump-info {
      font-size: 14px;
      font-weight: normal;
      color: #666;
      margin-left: 8px;
    }
    .el-dropdown-link {
      font-size: 14px;
      cursor: pointer;
      color: #409eff;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  .tip {
    color: #999;
    font-size: 12px;
    margin-bottom: 1em;
  }
}
.service-website {
}
</style>
